module.exports = __webpack_public_path__ + "static/img/tdf-logo.67e76d0.png";